import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NgwWowService } from 'ngx-wow';
// import { MatSelectSearchVersion } from 'ngx-mat-select-search';
// import { VERSION } from '@angular/material/core';
import {AuthService} from 'src/app/services/auth-service.service';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  // title = 'PGI';
  userParamName;
  roleId;
  href:String;
  authCode:any;
  authDetails:any=null;
  loginType="";
  constructor(private wowService: NgwWowService, private authService:AuthService, private router:Router ,private http: HttpClient) {
if(window.location.href.includes("?code=") && (sessionStorage.getItem("authDetails") =="null" || sessionStorage.getItem("authDetails") ==null)){
  
  this.getUserCredential();
}else{
  if(window.location.href.includes("?code=") && sessionStorage.getItem("authDetails") !=null){
    this.router.navigate(['/sandbox/home']);
  }else{
    sessionStorage.setItem("authDetails",null);
  }
  // this.router.navigate(['/sandbox']);
//   this.loginType=sessionStorage.getItem('loginType');
//   this.userParamName = JSON.parse(sessionStorage.getItem('currentUser')).paramName;
//   this.roleId=JSON.parse(sessionStorage.getItem('currentUser')).roleId
}
   }

  ngOnInit() {
 

    this.wowService.init();
  }

      getUserCredential(){
    this.authCode=window.location.href.split('=')[1];
        
    const data={'authcode':this.authCode,'authcredential':btoa("pgi:pin"),'redirectUrl':'http://10.25.26.251:4200'}
    // alert("data for user credential--->"+JSON.stringify(data));
    this.authService.getAuthUserDetails(data).subscribe(res => {
      this.authDetails=JSON.stringify(res);
      // alert(this.authDetails)
      sessionStorage.setItem("authDetails",this.authDetails);
      var paramName="";
      var paramValue="";
    if(res.ApplicationDetails[0].roleName=="ROLE_PGI_MINISTRY"){
      paramName="MIN";
      paramValue="";
    }
      var userJSON= {"username":res.user_name,"token":res.token,"paramName":paramName,"paramValue":paramValue,"roleId":res.ApplicationDetails[0].permision,"schema_name":null,"stateId":res.ApplicationDetails[0].stateId,"stateName":res.ApplicationDetails[0].stateName,"districtName":res.ApplicationDetails[0].districtName,"districtId":res.ApplicationDetails[0].districtId,"groupId":null};
      sessionStorage.setItem("currentUser",JSON.stringify(userJSON));
      this.userParamName = JSON.parse(sessionStorage.getItem('currentUser')).paramName;
      this.roleId=JSON.parse(sessionStorage.getItem('currentUser')).roleId
      sessionStorage.setItem("loginType","Auth");
      this.loginType=sessionStorage.getItem('loginType');
      this.router.navigate(['/sandbox/home']);
    })
  }

  // matSelectSearchVersion = MatSelectSearchVersion;
  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 2000);
  }



}
